import {KeyLabel} from './key-label.model';
export enum BridgeAdUnitDpHbIdStatus {
  N_A = 'N_A',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export const BridgeAdUnitDpHbIdStatusLabels = {
  N_A: 'Not available',
  APPROVED: 'Approved',
  PENDING: 'Pending',
  REJECTED: 'Rejected'
};

export const BridgeAdUnitDpHbIdStatusKL = () =>
  (Object.keys(BridgeAdUnitDpHbIdStatusLabels).map(key => new KeyLabel<BridgeAdUnitDpHbIdStatus>(<BridgeAdUnitDpHbIdStatus>key, BridgeAdUnitDpHbIdStatusLabels[key])));

export const BridgeAdUnitDpHbIdStatusKLDemandPartners = () =>
  BridgeAdUnitDpHbIdStatusKL().filter(x => x.key !== BridgeAdUnitDpHbIdStatus.N_A);
